import { render, staticRenderFns } from "./NTooltip.vue?vue&type=template&id=2221a830"
import script from "./NTooltip.vue?vue&type=script&lang=js"
export * from "./NTooltip.vue?vue&type=script&lang=js"
import style0 from "./NTooltip.vue?vue&type=style&index=0&id=2221a830&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports